import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { AmountFormat } from '../../Format/AmountFormat';
import DetailsRow from './DetailsRow';

const Petitions = ({ petitions }) => {
  const { t } = useTranslation();
  return (
    <div>
      {petitions?.map((petition, index) => {
        return (
          <table style={{ marginBottom: '16px' }} key={index}>
            <tbody>
              {petition.amount && (
                <DetailsRow
                  label={t(`onboard.customer.singleView.credit.amount`)}
                  value={
                    <AmountFormat
                      isCents={false}
                      amount={petition.amount.amount}
                      currencyCode={petition.amount.currency}
                      fractionDigits="0"
                    />
                  }
                />
              )}
              {petition.date && (
                <DetailsRow label={t(`onboard.customer.singleView.credit.date`)} value={petition.date} />
              )}
              {petition.creditor && (
                <DetailsRow label={t(`onboard.customer.singleView.credit.creditor`)} value={petition.creditor.name} />
              )}
              {petition.description && (
                <DetailsRow label={t(`onboard.customer.singleView.credit.description`)} value={petition.description} />
              )}
            </tbody>
          </table>
        );
      })}
    </div>
  );
};

Petitions.propTypes = {
  petitions: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
      }),
      date: PropTypes.string,
      creditor: PropTypes.shape({
        name: PropTypes.string,
      }),
      description: PropTypes.string,
    }),
  ),
};

export default Petitions;
